import {
	Box,
	Button,
	Link,
	useColorModeValue,
} from '@chakra-ui/react'
import { useRecoilValue } from 'recoil'

import { circlesBreakpointState } from '../../../state'
import { BITCOIN_ORANGE, menuLabelFontSize } from '../../../constants'
import { getBreakpointValue } from '../../../utils'

export const TCAppButton = ({ ...rest }) => {
	const circlesBreakpoint = useRecoilValue(circlesBreakpointState)
	const color = useColorModeValue('black', 'white')
	const bg = useColorModeValue('#eee', 'black')
	const interactionStyle = {
		borderColor: BITCOIN_ORANGE,
		color: BITCOIN_ORANGE,
	}
	const responsiveButtonLabelSize = getBreakpointValue(menuLabelFontSize, circlesBreakpoint)
	const buttonHeight = getBreakpointValue({ base: '30px', lg: '38px' }, circlesBreakpoint)
	const buttonLineHeight = getBreakpointValue({ base: '26px', lg: '36px' }, circlesBreakpoint)
	const buttonWrapFlex = getBreakpointValue({ base: '1 1 50%', lg: '1 1 20%' }, circlesBreakpoint)

	return (
		<Box
			className="tc-app-button-wrap"
			flex={buttonWrapFlex}
			role="group"
			pos="relative"
			zIndex={1015}
			{...rest}
		>
			<Link href="/app" _hover={{ textDecoration: 'none' }}>
				<Button
					w="100%"
					size="sm"
					variant="outline"
					bg={bg}
					fontSize={responsiveButtonLabelSize}
					fontWeight="bold"
					height={buttonHeight}
					lineHeight={buttonLineHeight}
					textTransform="uppercase"
					py="0"
					px="12px"
					color={color}
					borderColor={color}
					borderWidth={0}
					borderRadius="md"
					_active={interactionStyle}
					_hover={interactionStyle}
					_groupHover={interactionStyle}
				>
					APP
				</Button>
			</Link>
		</Box>
	)
}